import React, { useState } from 'react';
import { AppHeader } from './AppHeader';
import { AppFooter } from './AppFooter';
import { AppSidebar } from './AppSidebar';
import { PageAccessGuard } from './PageAccessGuard';

interface AppShellProps {
  children: React.ReactNode;
  /** Set false so the global header scrolls away (delivery mobile list/detail). */
  stickyHeader?: boolean;
}

export const AppShell: React.FC<AppShellProps> = ({
  children,
  stickyHeader = true,
}) => {
  const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false);
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <AppHeader
        onMobileMenuToggle={() => setMobileSidebarOpen(!mobileSidebarOpen)}
        onSidebarToggle={() => setSidebarCollapsed(!sidebarCollapsed)}
        sidebarCollapsed={sidebarCollapsed}
        sticky={stickyHeader}
      />
      
      <div className="flex-1 flex">
        {/* Desktop Sidebar */}
        <div className={`hidden lg:block flex-shrink-0 transition-all duration-300 ease-in-out ${
          sidebarCollapsed ? 'w-16' : 'w-48'
        }`}>
          <AppSidebar 
            collapsed={sidebarCollapsed}
            onToggleCollapse={() => setSidebarCollapsed(!sidebarCollapsed)}
          />
        </div>
        
        {/* Mobile Sidebar Overlay */}
        {mobileSidebarOpen && (
          <div className="lg:hidden fixed inset-0 z-50">
            <div 
              className="fixed inset-0 bg-gray-600 bg-opacity-75 transition-opacity"
              onClick={() => setMobileSidebarOpen(false)}
            />
            <div className="fixed inset-y-0 left-0 w-48 bg-white shadow-xl">
              <AppSidebar 
                collapsed={false}
                onToggleCollapse={() => setMobileSidebarOpen(false)}
                showCollapseButton={true}
              />
            </div>
          </div>
        )}
        
        {/* Main content */}
        <main className="flex-1 min-w-0 transition-all duration-300 ease-in-out">
          <div className="p-4 sm:p-6">
            <PageAccessGuard>{children}</PageAccessGuard>
          </div>
        </main>
      </div>
      
      <AppFooter />
    </div>
  );
};


